import React, { createContext, useContext } from 'react';
import useRemoteConfig from '../hooks/useRemoteConfig';

const RemoteConfigContext = createContext({
    config: {},
    loaded: false,
});

export const useConfig = () => useContext(RemoteConfigContext);

/**
 * Provides Remote Config values to the entire app tree.
 * Also acts as a maintenance gate — if maintenance_mode is true,
 * shows a maintenance screen instead of the app.
 */
export const RemoteConfigProvider = ({ children }) => {
    const { config, loaded } = useRemoteConfig();

    // Maintenance mode gate
    if (loaded && config.maintenance_mode) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                color: 'white',
                padding: '2rem',
                textAlign: 'center',
            }}>
                <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🔧</div>
                <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.5rem' }}>
                    Under Maintenance
                </h1>
                <p style={{ opacity: 0.7, maxWidth: '400px', lineHeight: 1.6 }}>
                    {config.maintenance_message || 'Tourminator is currently being updated. We\'ll be back shortly.'}
                </p>
            </div>
        );
    }

    return (
        <RemoteConfigContext.Provider value={{ config, loaded }}>
            {children}
        </RemoteConfigContext.Provider>
    );
};

export default RemoteConfigProvider;
